import type { JSX } from 'react';

import { cn } from '@change/ds-utils';

type CarouselDotsProps = {
	totalItems: number;
	activeIndex: number;
};

export function CarouselDots({ totalItems, activeIndex }: CarouselDotsProps): JSX.Element {
	return (
		<div className="flex justify-center gap-1.5">
			{Array.from({ length: totalItems }, (_, index) => (
				<div
					key={`carousel-dot-${index}`}
					className={cn(
						'h-2 w-2 rounded-full transition-colors',
						activeIndex === index ? 'bg-icon-accent-primary' : 'bg-fill-weaker',
					)}
				/>
			))}
		</div>
	);
}
